
































































import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { Statistics } from "@foxone/api/src/models/hfox";
import { USDT_ASSET } from "hfox/constants";

@Component
class Overview extends Vue {
  @State(state => state.hfox.statistics) statistics!: Statistics;

  get meta() {
    const toFiat = this.$common.utils.currency.fiat;
    const statistics = this.statistics || {};
    const totalFunds = toFiat(this, {
      value: statistics.total_funds || 0,
      from: USDT_ASSET.symbol
    });
    const totalRevenue = toFiat(this, {
      value: statistics.total_earn || 0,
      from: USDT_ASSET.symbol
    });
    const lastRevenue = toFiat(this, {
      value: statistics.yesterday_earn || 0,
      from: USDT_ASSET.symbol
    });
    const totalValue = toFiat(this, {
      value: statistics.total_value,
      from: USDT_ASSET.symbol
    });
    const totalTimes = statistics.filled_schedules || 0;
    const lastRevenueText = this.$common.utils.number.addSymbol(lastRevenue);
    const totalRevenueText = this.$common.utils.number.addSymbol(totalRevenue);
    const totalRateText = this.$common.utils.number.toPercent(
      statistics.total_earn_rate || 0,
      true
    );

    return {
      lastRevenueText,
      totalRevenueText,
      totalRateText,
      totalTimes,
      totalFunds,
      symbol: USDT_ASSET.symbol,
      totalValueText: totalValue,
      lastRevenueColor: this.$common.utils.helper.getColor(
        this.$store,
        statistics.yesterday_earn
      ),
      totalRevenueColor: this.$common.utils.helper.getColor(
        this.$store,
        statistics.total_earn
      ),
      iconShare: require("@/assets/images/icon_share.png")
    };
  }
}
export default Overview;
